// Camera paths are sampled in orbit space: no straight chord through the subject.
const clamp=t=>Math.max(0,Math.min(1,t));
const ease=t=>{t=clamp(t);return t*t*t*(t*(t*6-15)+10);};
const mix=(a,b,t)=>a+(b-a)*t;
const orbit=s=>{const d=s.position.map((v,i)=>v-s.target[i]),r=Math.hypot(...d);return {r:Math.max(.01,r),theta:Math.atan2(d[0],d[2]),phi:Math.acos(Math.max(-1,Math.min(1,d[1]/Math.max(.01,r))))};};
export function sampleFlight(from,to,progress,bridge=false){
 const t=clamp(progress);if(t===0||t===1){const s=t===0?from:to;return {position:[...s.position],target:[...s.target],zoom:s.zoom};}
 const a=ease(t),f=orbit(from),b=orbit(to),angle=Math.atan2(Math.sin(b.theta-f.theta),Math.cos(b.theta-f.theta));
 const bump=64*t*t*t*(1-t)*(1-t)*(1-t),r=Math.exp(mix(Math.log(f.r),Math.log(b.r),a))*(1+(bridge?.045:0)*bump);
 const theta=f.theta+angle*a,phi=Math.max(.025,mix(f.phi,b.phi,a)-(bridge?.045:0)*bump),target=from.target.map((v,i)=>mix(v,to.target[i],a));
 let zoom=Math.exp(mix(Math.log(from.zoom),Math.log(to.zoom),a));
 if(bridge){const wide=Math.min(from.zoom,to.zoom,1.15);zoom=t<.5?Math.exp(mix(Math.log(from.zoom),Math.log(wide),ease(t*2))):Math.exp(mix(Math.log(wide),Math.log(to.zoom),ease((t-.5)*2)));}
 return {position:[target[0]+r*Math.sin(phi)*Math.sin(theta),target[1]+r*Math.cos(phi),target[2]+r*Math.sin(phi)*Math.cos(theta)],target,zoom};
}
export const TOUR_SHOTS=[
 {title:'建筑全景',caption:'科研楼整体形态与场地关系',view:'assembled',hold:7},
 {title:'空间分层',caption:'五层空间展开 · 建筑与系统分布',view:'exploded',hold:6},
 {title:'二层导览',caption:'从楼层进入 203 实验室',view:'floor',floor:'F2',hold:5},
 {title:'实验室精览',caption:'实验台、精密仪器与机电服务',view:'room',asset:'ROOM-203',hold:9},
 {title:'屋顶机组',caption:'EF-03 排风机 · 机组与管路细节',view:'equipment',asset:'EF-03',hold:9},
 {title:'全景收束',caption:'回到建筑全貌 · 循环展示',view:'assembled',hold:6},
];
export class TourPlayback {
 constructor(){this.active=false;this.playing=false;this.index=0;this.elapsed=0;}
 get current(){return TOUR_SHOTS[this.index];}
 start(autoplay=true){this.active=true;this.playing=autoplay;this.index=0;this.elapsed=0;}
 go(i){this.index=Math.max(0,Math.min(TOUR_SHOTS.length-1,Math.round(i)||0));this.elapsed=0;this.playing=false;}
 play(){this.playing=true;}
 pause(){this.playing=false;}
 stop(){this.active=false;this.playing=false;this.elapsed=0;}
 tick(dt,{moving=false,paused=false,reducedMotion=false}={}){if(!this.active||!this.playing||moving||paused||reducedMotion)return false;this.elapsed+=Math.max(0,Number.isFinite(dt)?dt:0);if(this.elapsed<this.current.hold)return false;this.elapsed=0;this.index=(this.index+1)%TOUR_SHOTS.length;return true;}
}
